// @owners { team: patients }
import { COLORS } from '@alto/design-library-tokens';

export type ProgressBarProps = {
  completedSteps: number;
  totalSteps: number;
  animationDuration: number;
  incompleteColor: string;
};

export const getProgynyProgressBarProps = (currentRouteName: string | undefined): ProgressBarProps => {
  let completedSteps = 0;

  switch (currentRouteName) {
    case 'RouteProgynyWizardStartDate':
      completedSteps = 1;
      break;

    case 'RouteProgynyWizardTriggerDate':
      completedSteps = 1;
      break;

    case 'RouteProgynyWizardDosageCheck':
      completedSteps = 2;
      break;

    case 'RouteProgynyWizardLeftoverMeds':
      completedSteps = 3;
      break;

    default:
  }

  return {
    completedSteps,
    totalSteps: 3,
    animationDuration: 1000,
    // FuzeRx has no pink pages, so the track uses the brand's own `PROGRESS_BAR_INCOMPLETE` — the
    // `SteppedProgressBar` default (PH-4224).
    incompleteColor: COLORS.BACKGROUND_COLORS.PROGRESS_BAR_INCOMPLETE,
  };
};
